module.exports = __webpack_public_path__ + "img/rightbanner.75a9a987.png";